import { FC } from 'react';

import { FormattingSpanWrapper } from '../wrappers/FormattingSpanWrapper.jsx';
import { FormattedFieldProps } from './types.js';
import CurrencyVariant from './Variants/CurrencyVariant.jsx';
import DateVariant from './Variants/DateVariant.jsx';
import GoalVariant from './Variants/GoalVariant.jsx';
import LinkVariant from './Variants/LinkVariant.jsx';
import NumberVariant from './Variants/NumberVariant.jsx';
import PercentVariant from './Variants/PercentVariant.jsx';
import TextVariant from './Variants/TextVariant.jsx';

const FormattedField: FC<FormattedFieldProps> = (props) => {
  const { scale, value, variant, color } = props;

  const renderFormattedField = () => {
    switch (variant) {
      case 'number': {
        return (
          <NumberVariant
            value={value}
            decimalLimit={props.decimalLimit}
            prefix={props.prefix}
            isEmptyValueHidden={props.isEmptyValueHidden}
          />
        );
      }
      case 'percent': {
        return (
          <PercentVariant
            value={value}
            decimalLimit={props.decimalLimit}
            isEmptyValueHidden={props.isEmptyValueHidden}
          />
        );
      }
      case 'currency': {
        return (
          <CurrencyVariant
            currency={props.currency}
            value={value}
            decimalLimit={props.decimalLimit}
            isEmptyValueHidden={props.isEmptyValueHidden}
            scale={scale}
            color={color}
          />
        );
      }
      case 'date': {
        return <DateVariant value={value} scale={scale} />;
      }
      case 'goal': {
        return (
          <GoalVariant
            currency={props.currency}
            value={value}
            scale={scale}
            color={color}
          />
        );
      }
      case 'link': {
        return (
          <LinkVariant
            value={value}
            scale={scale}
            color={color}
            linkProps={props.linkProps}
          />
        );
      }
      case 'text':
      default: {
        return (
          <TextVariant scale={scale} color={color}>
            {value}
          </TextVariant>
        );
      }
    }
  };

  return (
    <FormattingSpanWrapper $scale={scale} color={color}>
      {renderFormattedField()}
    </FormattingSpanWrapper>
  );
};

export default FormattedField;
